//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//
import { Provider } from "react-redux";
import "./App.css";
import Navigation from "./components/Navigation";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import "jquery/dist/jquery.min.js";
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
//--------------------------------------------------------------------All Imports---------------------------------------------------------------------------//

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter>
          <Navigation />
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
